export const APP_NAME = "TxApp";
export const APP_KEY = "txapp";
export const APP_LOGO = "/logo_txapp.svg"; // Logo TxApp SVG

// Redirect Paths
export const getHomePath = () => {
    const appMode = import.meta.env.VITE_APP_MODE || import.meta.env.MODE;
    if (appMode === "driver") return "/driver/activity";
    if (appMode === "admin") return "/admin/overview";
    if (appMode === "entreprise") return "/entreprise/dashboard";
    return "/driver/activity"; // Default fallback
};
export const HOME_PATH = getHomePath();
export const GHOST_ENTRY_PATH = "/login";
export const REDIRECT_URL_KEY = "redirect";

// Navigation Types
export const NAV_TYPE_ROOT = 'root'
export const NAV_TYPE_GROUP = 'group';
export const NAV_TYPE_COLLAPSE = 'collapse';
export const NAV_TYPE_ITEM = 'item';
export const NAV_TYPE_DIVIDER = 'divider';

export const COLORS = ['neutral', 'primary', 'secondary', 'info', 'success', 'warning', 'error']